import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import color from 'color';
import _ from 'lodash';
import SMTeamLogo from '../SMTeamLogo';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const TblContainer = styled.table`
    border-collapse: separate;
    border-spacing: 1px;
    width: 100%;

    tbody {
        transform: skew(-${props => props.theme.skins.skew.angle}deg);
    }
`;

const TH = styled.td`
    text-align: center;
    line-height: 28px;
    color: ${props => props.theme.color};

    ${props => (props.bold ? 'font-weight: 700;' : '')};
`;

const HeaderTr = styled.tr`
    font-size: 30px;
    line-height: 1.475em;
    text-transform: uppercase;

    &:nth-child(1) {
        transform: skew(${props => props.theme.skins.skew.angle}deg);
    }
`;

const TD = styled.td`
    text-align: ${props => (props.left ? 'left' : 'center')};
    padding-left: ${props => props.paddingLeft};
    text-transform: uppercase;

    font-size: 30px;
    line-height: 1.475em;
    white-space: nowrap;

    &.tts-team-logo,
    &.tts-team-name,
    .rel-rank {
        display: flex;
        align-items: center;
        transform: skew(${props => props.theme.skins.skew.angle}deg);
    }

    &.tts-team-name {
        padding-left: 14px;
    }

    .rel-rank {
        display: inline-block;
    }
`;

const QualRelTR = styled.tr`
    position: relative;
    color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    background-color: ${props => (props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor)};
    font-weight: ${props => props.theme.fonts.main.bold};

    td {
        position: relative;
        color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};

        .rel-badge {
            display: inline-block;
            background-color: ${props =>
                (props.type && color(props.theme.qualRelColors[props.type]).toString()) ||
                props.theme.qualRelColors.relegation};
            width: 6px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: -9px;
            transform: skew(0deg);
        }

        &.tts-team-value {
            background-color: ${props =>
                props.high
                    ? color(props.theme.content.accentColor)
                          .lighten(0.1)
                          .rgb()
                          .toString()
                    : color(props.theme.content.backgroundColor)
                          .lighten(0.1)
                          .rgb()
                          .toString()};
        }

        &.tts-team-rank,
        &.tts-team-value-points {
            border: 1px solid ${props => props.theme.content.accentTextColor};
            background-color: ${props => props.theme.content.accentColor};
            color: ${props => props.theme.content.accentTextColor};
        }

        > span {
            display: inline-block;
            transform: skew(${props => props.theme.skins.skew.angle}deg);
        }
    }
`;

const Row = ({ row, qualRel, highlight, tournamentId }, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');

    return (
        <QualRelTR key={row.rank} type={qualRel && row.rankType} high={highlight}>
            <TD width="8%" className="tts-team-rank">
                {qualRel && <span className="rel-badge" />}
                <span className="rel-rank">{row.rank}</span>
            </TD>

            <TD left className="tts-team-name">
                <SMTeamLogo
                    style={{
                        marginRight: 15,
                        verticalAlign: 'middle'
                    }}
                    tournamentId={tournamentId}
                    teamId={row.teamId}
                    width={28}
                    height={28}
                />
                {row.teamName}
            </TD>
            <TD width="8%" className="tts-team-value">
                <span>{row.matchesWon}</span>
            </TD>
            <TD width="8%" className="tts-team-value">
                <span>{row.matchesDraw}</span>
            </TD>
            <TD width="8%" className="tts-team-value">
                <span>{row.matchesLost}</span>
            </TD>
            <TD width="8%" className="tts-team-value-points">
                <span>{row.points}</span>
            </TD>
        </QualRelTR>
    );
};

const Header = (props, ctx) => {
    let lang = _.get(ctx, 'info.lang', 'en');

    return (
        <HeaderTr>
            <TH />

            <TH />
            <TH>{i18('win.short', lang)}</TH>
            <TH>{i18('draw.short', lang)}</TH>
            <TH>{i18('loss.short', lang)}</TH>
            <TH>{i18('points.short', lang)}</TH>
        </HeaderTr>
    );
};

Row.contextTypes = {
    info: PropTypes.object
};

Header.contextTypes = {
    info: PropTypes.object
};

const Container = ({ children }) => (
    <TblContainer>
        <tbody>{children}</tbody>
    </TblContainer>
);

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/SkewTT.js
 **/